const actions = {
    FETCH_TAGLIST_REQUEST: "FETCH_TAGLIST_REQUEST",
    FETCH_TAGLIST_SUCCESS: "FETCH_TAGLIST_SUCCESS",
    FETCH_TAGLIST_ERROR: "FETCH_TAGLIST_ERROR",
    fetchTagList: () => ({
        type: actions.FETCH_TAGLIST_REQUEST
    })
};
export default actions;
